import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, RouterModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {

  constructor(public translationService: TranslationService, private authService: AuthService) {}

  switchLanguage(): void {
    const newLang = this.translationService.currentLanguage === 'en' ? 'ar' : 'en';
    this.translationService.setLanguage(newLang);
  }

  logout(): void {
    this.authService.logout();
  }
}
